import { Component, inject, Input, OnInit } from '@angular/core';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  DxDataGridComponent,
  DxPopupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import { AllegatiArticoliService } from 'src/app/shared/services/allegati-articoli.service';
import CustomStore from 'devextreme/data/custom_store';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { ConvertError } from 'src/app/utils/gestione-errori';
import * as FileSaver from 'file-saver';
import { AllegatiArticoli } from 'src/app/models/allegati-articoli';
import { confirm } from 'devextreme/ui/dialog';
import { TAB_ALLEGATI_ARTICOLI } from 'src/app/consts/const';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { FormAllegatoComponent } from '../../form/form-allegato/form-allegato.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-grid-allegati-articolo',
  templateUrl: './grid-allegati-articolo.component.html',
  styleUrls: ['./grid-allegati-articolo.component.scss'],
  imports: [
    DxDataGridComponent,
    DxPopupComponent,
    DxiColumnComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoExportComponent,
    DxoColumnChooserComponent,
    DxiButtonComponent,
    DxTemplateDirective,
    FormAllegatoComponent,
  ],
})
export class GridAllegatiArticoloComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private allegatiArticoliService = inject(AllegatiArticoliService);
  private sanitizer = inject(DomSanitizer);
  @Input() idArticolo;

  dataSource: any;
  allegatiSource: any;

  columnResizingMode = 'widget';
  currentImage: SafeResourceUrl;
  popupImageVisible = false;

  //PopUp
  oggettoAllegato: string = '';
  visiblePopUpNewAllegato = false;
  value: any[] = [];
  tabRifAllegati: string = TAB_ALLEGATI_ARTICOLI;

  ngOnInit() {
    if (this.idArticolo) {
      this.loadDati();
    }
  }

  loadDati() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.allegatiArticoliService
          .listByArticolo(this.idArticolo))
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
    });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        name: 'nuovo',
        class: 'success',
        onClick: this.apriPopUp.bind(this),
      },
    });
  }

  getFile(allegato) {
    if (allegato) {
      this.allegatiArticoliService.scarica(allegato.id).subscribe({
        next: (res) => {
          if (res != null) {
            //const url = window.URL.createObjectURL(res);
            //window.open(url);
            FileSaver.saveAs(res, allegato.nomeFile);
          } else {
            notificaMessaggio('Documento non presente', 'warning');
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero documento allegato', true);
        },
      });
    }
  }

  scaricaFile(allegato: AllegatiArticoli) {
    this.allegatiArticoliService.scarica(allegato.id).subscribe((res) => {
      FileSaver.saveAs(res, allegato.nomeFile);
    });
  }

  eliminaFile(allegato: AllegatiArticoli) {
    const result = confirm('<i>Vuoi eliminare l\'allegato?</i>', 'Conferma');
    result.then((dialogResult) => {
      if (dialogResult) {
        this.allegatiArticoliService.delete(allegato.id).subscribe(() => {
          console.log('Allegato eliminato');
          this.loadDati();
          /* this.allegatiArticoliService.list().subscribe((dati) => {
             this.allegatiList = dati;
             console.log(dati);
             this.allegatiArticoloDataSourceStorage = [];
           });*/
        });
      }
    });
  }

  visualizzaFile(allegato: AllegatiArticoli) {
    this.allegatiArticoliService.scarica(allegato.id).subscribe((res) => {
      const url = window.URL.createObjectURL(res);
      window.open(url);
    });
  }

  visualizzaImmagine(allegato: AllegatiArticoli) {
    this.allegatiArticoliService.getImmagine(allegato.id).subscribe((res) => {
      this.currentImage = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image;base64,' + res,
      );
      this.popupImageVisible = true;
    });
  }

  apriPopUp() {
    this.visiblePopUpNewAllegato = true;
  }

  onExporting(e) {
    GridExportExcel(e, 'AllegatiArticolo', 'AllegatiArticolo.xlsx');
  }

  ricaricaAllegatiEvent(e) {
    this.visiblePopUpNewAllegato = false;
    if (e == true) {
      this.loadDati();
    }
  }

  endsWith(str, suffix) {
    if (str == undefined) {
      return false;
    }
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }
}

